module.exports = __webpack_public_path__ + "static/media/aspire-campus-banner.95395d33.jpg";